// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2lrpk","title":"FrontImage_title__rc7vj"};